import { DocumentoFiscalEmitidoDownloadStruct } from '../../structs/repo-dfe/documento-fiscal-emitido-download.struct';

export class DownloadDocumentosFiscaisEmitidosRequest {
    documentos: DocumentoFiscalEmitidoDownloadStruct[] = [];
}
